import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { CopyPasteExcelService } from 'src/app/application/service/CopyPasteExcelService';

@Component({
  selector: 'app-copy-paste-excel',
  templateUrl: './copy-paste-excel.component.html',
  styleUrls: ['./copy-paste-excel.component.css']
})
export class CopyPasteExcelComponent {
  @Output() getPastedPallets = new EventEmitter<boolean>()

  pastedText: string = '';
  headers: string[] = [];
  rows: any[] = [];
  isDisplayTable: boolean = false;
  private readonly destroy = new Subject<void>();

  constructor(
    private readonly copyPasteExcelService: CopyPasteExcelService,
    private readonly messageService: MessageService,
    public readonly translate: TranslateService
  ) {}

  ngOnInit() {
    this.copyPasteExcelService.getIsDisplayTable().pipe(takeUntil(this.destroy)).subscribe((displayTable) => {
      this.isDisplayTable = displayTable;
      if (displayTable && this.rows.length > 0) {
        this.copyPasteExcelService.setParsedExcelData(this.rows);
      }
    })
    this.copyPasteExcelService.getIsClearTextArea().pipe(takeUntil(this.destroy)).subscribe((_) => {
      this.pastedText = '';
      this.setTextAreaData('');
    })
  }

  getExcelRows() {
    if (!this.pastedText) return;
  
    const rawLines = this.pastedText.trim().split(/\r?\n/);
  
    const rows: string[][] = rawLines
      .map(line => line.split('\t').map(cell => cell.trim()))
      .filter(columns => columns.length > 1);
  
    this.rows = rows.map(row => {
      const rowObj: any = {};
      row.forEach((value, index) => {
        rowObj[`col${index}`] = value;
      });
      return rowObj;
    });
  
    this.headers = Object.keys(this.rows[0] ?? {});
    return this.rows;
  }

  onChangeText(text: any) {
    this.pastedText = text;
    const dataRows: any = this.getExcelRows();
    this.getPastedPallets.emit(dataRows?.length > 0)
  }

  handlePaste(event: ClipboardEvent) {
    event.preventDefault();

    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const text = clipboardData.getData('text');
    this.setTextAreaData(text)
  }

  setTextAreaData(text: string) {
    const rows = text.trim().split('\n');

    const cleanedRows = rows
      .map((row: any) => row.split('\t').map((cell: any) => cell.trim()).join('\t'))
      .filter((row: any) => row.trim() !== '');

    this.pastedText = cleanedRows.join('\n');
    this.validateTextAreaData()
  }

  validateTextAreaData() {
    const dataRows: any = this.getExcelRows();
    this.getPastedPallets.emit(dataRows?.length > 0)
    if (dataRows?.length === 0) {
      this.messageService.add({ 
        severity: 'error',
        summary:this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('UserPages.UserPurchaseOrders.VerifyPalletsPage.ErrorPasteText') 
      })
    }
  }
  
  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }
}
